import { render, staticRenderFns } from "./UploadContatos.vue?vue&type=template&id=32e61702&scoped=true"
import script from "./UploadContatos.vue?vue&type=script&lang=js"
export * from "./UploadContatos.vue?vue&type=script&lang=js"
import style0 from "./UploadContatos.vue?vue&type=style&index=0&id=32e61702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e61702",
  null
  
)

export default component.exports